import { render, staticRenderFns } from "./whyReglory.vue?vue&type=template&id=b0ff271c&scoped=true&"
import script from "./whyReglory.vue?vue&type=script&lang=js&"
export * from "./whyReglory.vue?vue&type=script&lang=js&"
import style0 from "./whyReglory.vue?vue&type=style&index=0&id=b0ff271c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ff271c",
  null
  
)

export default component.exports